import React, { useState, useEffect } from 'react'
import { Link ,useNavigate } from "react-router-dom";
import $ from 'jquery';
import {toast} from 'react-toastify'
import axiosInstance from '../../config/axiosInterceptor';

const AddGarage = () => {

    const [type, setType] = useState("");

    const [submitting, setSubmitting] = useState(false);
    const [vipValid, setVipValid] = useState("");
    const [svgaName, setSvgaName] = useState("");
    const [thumbnailName, setThumbnailName] = useState("");

    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const vipId = params.get('vipId');

    // Items inside a VIP inherit the VIP's own validity - the admin doesn't
    // get to set it, so pull it from the VIP and show it read-only.
    useEffect(() => {
        if (!vipId) return;
        axiosInstance.get(`${process.env.REACT_APP_BASEURL5}/admin/vip/fetchVip?id=${vipId}`)
            .then((res) => {
                if (res.data.success === 1 && res.data.details) {
                    setVipValid(res.data.details.valid || "");
                }
            })
            .catch(() => { });
    }, [vipId]);

    const navigate = useNavigate();

    const subbbb = async (e) => {
        e.preventDefault(); 

        if (submitting) return;
        var a = $("select[name='type']").val();
        var b = $("input[name='title']").val();
        // Inside a VIP: price isn't charged (the VIP is), and valid comes from
        // the VIP itself - neither is entered by the admin.
        var c = vipId ? '0' : $("input[name='price']").val();
        var d = vipId ? vipValid : $("input[name='valid']").val();
        var e = $("input[name='svga']")[0].files[0]; // Access the file object
        var f = $("input[name='thumbnail']")[0].files[0]; // Access the file object
        let text = "This field cannot be empty";
        if(a == ''){
            $('.form-error1').html(text);
        }
        if(b == ''){
            $('.form-error2').html(text);
        }
        if(!vipId && c == ''){
            $('.form-error3').html(text);
        }
        if(d == ''){
            $('.form-error4').html(text);
        }
        if (a != '' && b != '' && c != '' && d != '')
        {
            // let formData = new FormData(e.target); // Use e.target to access the form element
            let formData = new FormData();
            formData.append('type', a);
            formData.append('title', b);
            formData.append('price', c);
            formData.append('valid', d);
            if (e) formData.append('svga', e);
            if (f) formData.append('thumbnail', f);
            if (vipId) formData.append('vipId', vipId);
            // niru - 27/2
            setSubmitting(true);
            await axiosInstance.post(`${process.env.REACT_APP_BASEURL5}/admin/entryeffects/addentryeffects`,formData).then((res)=>{
                if(res.data.success===1){
                    toast.success(res.data.message)
                    setTimeout(()=>{
                        navigate(vipId ? `/admin/viewVipPack?id=${vipId}` : '/admin/manageEntryEffect')
                    },1000)
                }else{
                    toast.error(res.data.message)
                    setSubmitting(false);
                }
            }).catch((e) => { toast.error(e.message); setSubmitting(false); });
            // $.ajax({
            //     url: `${process.env.REACT_APP_BASEURL}/admin/entryeffects/addentryeffects`,
            //     type: "POST",
            //     data: formData,
            //     contentType: false,
            //     processData: false,
            //     success: function(res) {
            //       if(res.success===1){
            //           toast.success(res.message)
            //           setTimeout(()=>{
            //                 navigate('/admin/manageEntryEffect')
            //           },1000)
            //       }else{
            //           toast.error(res.message)
            //       }
            //     }
            // });
        }
    }


    return (
        <>
            <section className="content-header">
                <h1>Add EntryEffects</h1>
                <ol className="breadcrumb">
                    <li><Link to="/admin"><i className="fa fa-dashboard"></i> Home</Link></li>
                    <li><Link to="/admin/manageAgency">Manage EntryEffects</Link></li>
                    <li className="active">Add EntryEffects</li>
                </ol>
            </section>
            <section className="content">
                <div className="row">
                    <div className="col-md-12">
                        <form role="form" id="form" method="post" onSubmit={subbbb} encType="multipart/form-data">
                            <div className="box box-warning">
                                <div className="box-header with-border">
                                    <h3 className="box-title">Title</h3>
                                </div>
                                <div className="box-body">
                                    {vipId && (
                                        <input type="hidden" name="vipId" value={vipId} />
                                    )}
                                    <div className="form-group">
                                        <label>Type*</label>
                                        <select type="text" className="form-control" name="type" value={vipId ? "VIP" : type} disabled={!!vipId} onChange={(e)=>{
                                            setType(e.target.value);
                                            $('.form-error1').html('');
                                        }}>
                                            <option value="">Select Type</option>
                                            <option value="ADMIN">ADMIN</option>
                                            <option value="PURCHASED">PURCHASED</option>
                                            <option value="VIP">VIP</option>
                                        </select>
                                        <div className="form-error1 text-danger"></div>
                                    </div>
                                    <div className="form-group">
                                        <label>Title*</label>
                                        <input type="text" className="form-control" name="title" placeholder="Title" onChange={()=>{
                                            $('.form-error2').html('');
                                        }} />
                                        <div className="form-error2 text-danger"></div>
                                    </div>
                                    {!vipId && (
                                        <div className="form-group">
                                            <label>Price*</label>
                                            <input type="number" className="form-control" name="price" placeholder="price" onChange={()=>{
                                                $('.form-error3').html('');
                                            }} />
                                            <div className="form-error3 text-danger"></div>
                                        </div>
                                    )}
                                    <div className="form-group">
                                        <label>Valid Days*</label>
                                        {vipId ? (
                                            <>
                                                <input type="number" className="form-control" value={vipValid} readOnly disabled />
                                                <small className="text-muted">Inherited from the VIP - all items expire with it.</small>
                                            </>
                                        ) : (
                                            <input type="number" className="form-control" name="valid" placeholder="valid days" onChange={()=>{
                                                $('.form-error4').html('');
                                            }} />
                                        )}
                                        <div className="form-error4 text-danger"></div>
                                    </div>
                                    <div className="form-group">
                                        <label>Svga</label>
                                        <input type="file" className="form-control" name="svga" onChange={(e)=>{
                                            setSvgaName(e.target.files[0] ? e.target.files[0].name : "");
                                        }} />
                                        {svgaName && <div className="text-success"><i className="fa fa-check"></i> {svgaName} attached</div>}
                                    </div>
                                    <div className="form-group">
                                        <label>Thumbnail</label>
                                        <input type="file" className="form-control" name="thumbnail" onChange={(e)=>{
                                            setThumbnailName(e.target.files[0] ? e.target.files[0].name : "");
                                        }} />
                                        {thumbnailName && <div className="text-success"><i className="fa fa-check"></i> {thumbnailName} attached</div>}
                                    </div>
                                    <div className="form-group">
                                        <button type="button" className="btn btn-default" onClick={()=>{
                                            $("#form")[0].reset();
                                            setType("");
                                            setSvgaName("");
                                            setThumbnailName("");
                                            $(".form-error1, .form-error2, .form-error3, .form-error4").html("");
                                        }}>Reset</button>{" "}
                                        <button type="button" className="btn btn-danger" onClick={() => navigate(vipId ? `/admin/viewVipPack?id=${vipId}` : '/admin/manageEntryEffect')}>Cancel</button>
                                        <button type="submit" className="btn btn-success pull-right" name="submit" disabled={submitting}>{submitting ? (<><i className="fa fa-spinner fa-spin mr-1" /> Saving...</>) : ("Submit")}</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AddGarage